import { BUBBLE_GAP, BUBBLE_HEIGHT } from './const';

export interface BubbleMarker {
  target: string;
  // Where the bubble would sit on its own: centred on the line its highlight ends on.
  top: number;
}

export interface BubbleCluster {
  key: string;
  top: number;
  targets: string[];
}

/**
 * Places the bubbles top to bottom. A bubble that would overlap the one above it joins it instead,
 * so a merged bubble stays next to its first line and lists everything it holds.
 */
export const placeBubbles = (markers: BubbleMarker[]): BubbleCluster[] =>
  [...markers]
    .sort((a, b) => a.top - b.top)
    .reduce<BubbleCluster[]>((clusters, marker) => {
      const last = clusters.at(-1);
      if (last && marker.top < last.top + BUBBLE_HEIGHT + BUBBLE_GAP) {
        last.targets.push(marker.target);
        return clusters;
      }
      return [...clusters, { key: marker.target, top: marker.top, targets: [marker.target] }];
    }, []);

/**
 * The bubble an open panel belongs to. Bubbles regroup when a highlight comes or goes. The panel
 * keeps the items it opened with. It follows the bubble that holds most of them.
 */
export const findOpenBubble = <T extends BubbleCluster>(
  bubbles: T[],
  openTargets: string[]
): T | undefined => {
  let best: T | undefined;
  let bestCount = 0;
  bubbles.forEach((bubble) => {
    const count = bubble.targets.filter((target) => openTargets.includes(target)).length;
    if (count > bestCount) {
      best = bubble;
      bestCount = count;
    }
  });
  return best;
};
